<template>
  <div v-if="show"
       class="sign-container"
       :class="[deviceType]">
    <div class="sign-panel">
      <van-icon ref="closeIcon"
                v-show="showCloseBtn"
                class="icon-close"
                name="cross"
                @click.stop="_close" />
      <div class="sign-comp-box">
        <div class="sign-comp-box__bg">
          <div class="sign-comp-box__wrap"></div>
          <!--<img src="@/static/images/signature/sign-bg.png" alt="" />-->
          <div v-if="bgTxt"
               class="sign-comp-box__username">{{ bgTxt }}</div>

        </div>
        <div class="sign-comp-box__sign">
          <vueEsign v-if="isMounted"
                    ref="esign"
                    :width="width"
                    :height="height"
                    :isCrop="isCrop"
                    :lineWidth="lineWidth"
                    :lineColor="lineColor" />
        </div>
      </div>
      <div class="action-bar">
        <div class="action-bar-wrap">
          <div class="action-bar__text">
            请
            <span class="action-bar__text__username">{{ username }}</span>
            签名
            <span class="action-bar__text__tip">请工整地横向签署您的姓名</span>
          </div>
          <div class="action-bar__btns">
            <button class="action-bar__btn action-bar__btn--default"
                    @click="handleReset">
              清除
            </button>
            <button class="action-bar__btn action-bar__btn--primary ok-bgcolor"
                    @click="handleConfirm">
              <!-- {{ btnName ? btnName : '提交' }} -->
              确认签名
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- <ScreenTip /> -->
  </div>
</template>

<script>
  import vueEsign from 'vue-esign';
  import { Toast } from 'vant';
  import wtsTools from '@/static/js/wtsTools.esm.min.js';
  import _ from 'lodash';
  import { getOrientationAngle } from '@/static/js/screen';

  /**
   * img旋转
   */
  class ImgRotate {
    /**
     * @param {object} options
     * @param {object} options.src
     * @param {0|90|180|270} options.angle 旋转角度
     */
    constructor({ src, angle }) {
      this.image = new Image();
      this.image.className = 'rr-ignore rr-block';
      this.image.src = src;
      this.canvas = document.createElement('canvas');
      this.canvas.className = 'rr-ignore rr-block';
      this.ctx = this.canvas.getContext('2d');
      this.angle = angle;
    }

    async rotate() {
      return new Promise(resolve => {
        let angles = [0, 90, 180, 270];
        this.image.onload = _ => {
          if (angles[this.angle] % 180 === 0) {
            this.canvas.width = this.image.width;
            this.canvas.height = this.image.height;
          } else {
            this.canvas.width = this.image.height;
            this.canvas.height = this.image.width;
          }
          switch (this.angle) {
            case 0: // 0
              this.ctx.translate(0, 0);
              break;
            case 1: // 90
              this.ctx.translate(this.canvas.width, 0);
              break;
            case 2: // 180
              this.ctx.translate(this.canvas.width, this.canvas.height);
              break;
            case 3: // 270
              this.ctx.translate(0, this.canvas.height);
              break;
            default:
              throw new ReferenceError('No angle');
              break;
          }
          this.ctx.rotate((angles[this.angle] * Math.PI) / 180);
          this.ctx.drawImage(this.image, 0, 0, this.image.width, this.image.height, 0, 0, this.image.width, this.image.height);
          resolve(this.canvas.toDataURL('image/png'));
        };
      });
    }
  }

  /**
   * img大小
   */
  class ImgSize {
    panelWidth = 400;
    panelHeight = 220;
    padding = 20;

    constructor() {
      this.canvas = document.createElement('canvas');
      this.canvas.className = 'rr-ignore rr-block';
      this.canvas.width = this.panelWidth;
      this.canvas.height = this.panelHeight;
      this.ctx = this.canvas.getContext('2d');
    }

    aspectFit(imageWidth, imageHeight, canvasWidth, canvasHeight) {
      const imageRate = imageWidth / imageHeight;
      const canvasRate = canvasWidth / canvasHeight;
      let [dx, dy, dw, dh] = [];
      if (imageRate >= canvasRate) {
        dw = canvasWidth;
        dh = canvasWidth / imageRate;
      } else {
        dh = canvasHeight;
        dw = canvasHeight * imageRate;
      }
      dx = (canvasWidth - dw) / 2;
      dy = (canvasHeight - dh) / 2;
      return [dx, dy, dw, dh];
    }

    gen(src) {
      return new Promise(resolve => {
        this.image = new Image();
        this.image.className = 'rr-ignore rr-block';
        this.image.src = src;
        this.image.onload = () => {
          console.log('this.image.width', this.image.width);
          const sizeResult = this.aspectFit(this.image.width, this.image.height, this.panelWidth - this.padding * 2, this.panelHeight - this.padding * 2);
          console.log('sizeResult', sizeResult);
          this.ctx.drawImage(this.image, sizeResult[0] + this.padding, sizeResult[1] + this.padding, sizeResult[2], sizeResult[3]);
          resolve(this.canvas.toDataURL('image/png'));
        };
      });
    }
  }

  /**
   * 屏幕尺寸发生变化时触发
   */
  function onScreenResize(ctx) {
    // 获取屏幕高度，并设置为css变量添加到body上
    // const angle = getOrientationAngle()
    const windowInnerWidth = window.innerWidth;
    const windowInnerHeight = window.innerHeight;
    // 向上竖屏
    // const width = angle === 0 ? windowInnerHeight : windowInnerWidth
    // document.body.style.setProperty('--portrait-height', `${width}px`)
    document.body.style.setProperty('--screen-real-width', `${windowInnerWidth}px`);
    document.body.style.setProperty('--screen-real-height', `${windowInnerHeight}px`);

    ctx.deviceType = wtsTools.tools.isMobile() ? 'mobile' : 'pc';

    ctx.setSignPanelSize();
  }

  export default {
    components: {
      vueEsign
      // ScreenTip,
    },
    props: {
      type: Number,
      btnName: String,
      username: {
        type: String,
        default: '用户姓名'
      },
      bgTxt: {
        type: String,
        default: ''
      },
      showCloseBtn: {
        type: Boolean,
        default: true
      }
    },
    data() {
      return {
        show: false,
        width: 0,
        height: 0,
        isMounted: false,
        isCrop: true,
        lineWidth: 3,
        lineColor: 'black',
        deviceType: ''
      };
    },
    beforeDestroy() {
      this.$store.commit('setExpectedOrientationType', 'portrait-primary');
      window.removeEventListener('resize', this._onScreenResize);
    },
    methods: {
      handleReset() {
        this.$refs.esign.reset();
        this.$emit('reset');
      },
      handleConfirm() {
        this.$refs.esign
          .generate()
          .then(res => {
            const _angle = getOrientationAngle();
            let angle = 1;
            if (wtsTools.tools.isMobile()) {
              switch (_angle) {
                case 0:
                  // 向上竖屏
                  angle = 3;
                  break;
                case 90:
                case -90:
                case 270:
                  // 横屏
                  angle = 0;
                  break;
                case 180:
                case -180:
                  // 向下竖屏
                  angle = 1;
                  break;
                default:
                  console.error('未获取到角度', angle);
              }
            } else {
              angle = 3;
            }
            const imgRotate = new ImgRotate({
              src: res,
              angle
            });
            const imgSize = new ImgSize();
            imgRotate.rotate().then(r => {
              imgSize.gen(r).then(_r => {
                this.$emit('confirm', { type: this.type, signInfo: _r });
              });
            });
          })
          .catch(err => {
            Toast({
              message: '您还没有签字！',
              duration: 2e3,
              position: 'middle'
            });
          });
      },
      // 设置签字面板宽高
      setSignPanelSize() {
        this.isMounted = false;
        clearTimeout(this.__timer__);
        this.__timer__ = setTimeout(() => {
          this.$refs?.esign?.reset();
          const el = document.querySelector('.sign-comp-box');
          this.height = el.offsetHeight;
          this.width = el.offsetWidth;
          console.log(`sign panel size: width:${this.width} height:${this.height}`);
          this.$nextTick(() => {
            this.isMounted = true;
          });
          clearTimeout(this.__timer__);
          this.__timer__ = null;
        }, 60);
      },
      open() {
        if (getOrientationAngle() === 0) {
          Toast({
            message: '请在横屏状态下签字',
            duration: 2e3,
            position: 'middle'
          });
        }
        let delay = this.$tools.isIOS() && this.$tools.isWeiXin() ? 350 : 0;
        this._onScreenResize = _.debounce(() => {
          onScreenResize(this);
        }, delay);
        window.addEventListener('resize', this._onScreenResize, false);
        this.$nextTick(() => {
          onScreenResize(this);
          this.isMounted = false;
          this.show = true;
        });
      },
      _close() {
        // 如果在此事件中返回false，则不执行关闭签字面板的操作
        const r = this.$emit('beforeClose');
        if (r === false) return;
        this.close();
        this.$emit('close');
      },
      close() {
        this.show = false;
        this.isMounted = false;
        window.removeEventListener('resize', this._onScreenResize);
      }
    }
  };
</script>

<style lang="scss" scoped>
.sign-container {
  position: fixed;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 51;
}

// 公共样式开始
.sign-panel {
  display: flex;
  position: absolute;
  z-index: 5;
  background-color: #fff;

  .icon-close {
    position: absolute;
    z-index: 5;
    /* prettier-ignore */
    font-size: 18PX;
    /* prettier-ignore */
    right: 10PX;
    /* prettier-ignore */
    padding: 10PX;
    color: #3c464f;
    // background-color: pink;
    cursor: pointer;
  }

  .sign-comp-box {
    background-color: #f5f6f9;
    .sign-comp-box__bg {
      position: absolute;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 100%;
      left: 0;
      top: 0;
      z-index: 0;
      &::before {
        content: '';
        width: 80%;
        height: 80%;
        border: 2px dashed #999;
        display: inline-block;
        position: absolute;
      }
      img {
        /* prettier-ignore */
        width: 350PX;
        /* prettier-ignore */
        height: 102PX;
      }
      .sign-comp-box__username {
        /* prettier-ignore */
        font-size: 102PX;
        white-space: nowrap;
        color: #ecedf3;
        line-height: 1;
        font-family: '楷体', '楷体_GB2312';
      }
    }
    .sign-comp-box__sign {
      position: absolute;
      width: 100%;
      height: 100%;
      left: 0;
      top: 0;
      z-index: 2;
    }
  }

  .action-bar-wrap {
    display: flex;
    justify-content: space-between;
    /* prettier-ignore */
    padding-left: 18PX;
    /* prettier-ignore */
    padding-right: 28PX;
  }
  .action-bar__text {
    display: flex;
    align-items: center;
    /* prettier-ignore */
    font-size: 14PX;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #17233d;
  }
  .action-bar__text__username {
    /* prettier-ignore */
    font-size: 16PX;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 500;
    /* prettier-ignore */
    padding: 0 5PX;
  }

  .action-bar__text__tip {
    /* prettier-ignore */
    font-size: 14PX;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #ff8700;
    /* prettier-ignore */
    margin-left: 18PX;
  }

  .action-bar__btns {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .action-bar__btn {
    display: flex;
    justify-content: center;
    align-items: center;
    /* prettier-ignore */
    width: 96PX;
    /* prettier-ignore */
    height: 37PX;
    /* prettier-ignore */
    border-radius: 5PX;
    /* prettier-ignore */
    margin-right: 14PX;
    /* prettier-ignore */
    font-size: 15PX;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #515a6e;
    cursor: pointer;

    &:last-child {
      margin-right: 0;
    }
  }
  .action-bar__btn--default {
    border: 1px solid #dddddd;
  }
  .action-bar__btn--primary {
    background-color: #236dff;
    color: #ffffff;
  }
}
// 公共样式结束

// 竖屏样式
@mixin portrait {
  .sign-panel {
    .icon-close {
      /* prettier-ignore */
      bottom: 10PX;
    }
    .action-bar {
      position: absolute;
      left: 0;
      top: 0;

      /* prettier-ignore */
      width: 55PX;
      height: 100%;
    }
    .action-bar-wrap {
      transform: rotate(90deg);
      /* prettier-ignore */
      transform-origin: 25PX 25PX;
      /* prettier-ignore */
      height: 55PX;
      // width: var(--portrait-height);
      width: var(--screen-real-height);
    }

    .sign-comp-box {
      position: absolute;
      right: 0;
      top: 0;
      // height: var(--portrait-height);
      height: var(--screen-real-height);
      /* prettier-ignore */
      width: calc(100vw - 55PX);

      .sign-comp-box__bg {
        img {
          transform: rotate(90deg);
        }
        .sign-comp-box__username {
          text-align: center;
          transform: rotate(90deg);
          display: flex;
          justify-content: center;
          align-items: center;
        }
      }
    }
  }
}

// 横屏样式
@mixin landscape {
  .sign-panel {
    flex-direction: column;
    .icon-close {
      /* prettier-ignore */
      top: 10PX;
    }
    .sign-comp-box {
      position: relative;
      flex: 1;
      // background-color: #fff;
      overflow: hidden;
    }
    .action-bar {
      width: 100%;
      display: flex;
      align-items: center;
      /* prettier-ignore */
      height: 55PX;
      /* prettier-ignore */
      flex: 0 0 55PX;
    }
    .action-bar-wrap {
      width: 100%;
    }
  }
}

.pc {
  @include portrait;
  .sign-panel {
    width: 750px;
    height: 100%;
    left: 50%;
    margin-left: -375px;
    .sign-comp-box {
      /* prettier-ignore */
      width: calc(100% - 55PX);
    }
  }
}

.mobile .sign-panel {
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}

// 竖屏样式
@media (orientation: portrait) {
  .mobile {
    @include portrait;
  }
}

// 横屏样式
@media (orientation: landscape) {
  .mobile {
    @include landscape;
  }
}
</style>
